import React from 'react';
import PropTypes from 'prop-types';
import { TopBar, MiddleBar, BottomBar, Container } from './BurgerMenu.styles';
import createThemedComponent from '../../../theming/utils/createThemedComponent/createThemedComponent';
/**
 * Animated burger menu component which can be used in any custom navigation element.
 *
 * This is NOT themeable.
 *
 * ## Example Usage
 *
 * ```js
 * import React, { useState } from 'react';
 * import { BugerMenu } from '@minerva-analytics/pantheon';
 *
 * const [open, setOpen] = useState(false);
 *
 * <BurgerMenu
 *   open={open}
 *   handleClick={() => {
 *     setOpen(!open);
 *   }}
 *   color='gray'
 * />
 * ```
 */

export var BurgerMenuComponent = function BurgerMenuComponent(_ref) {
  var color = _ref.color,
      open = _ref.open,
      handleClick = _ref.handleClick;
  return /*#__PURE__*/React.createElement(Container, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(TopBar, {
    open: open,
    color: color
  }), /*#__PURE__*/React.createElement(MiddleBar, {
    open: open,
    color: color
  }), /*#__PURE__*/React.createElement(BottomBar, {
    open: open,
    color: color
  }));
};
BurgerMenuComponent.propTypes = {
  /** Custom color for the animated favicons  */
  color: PropTypes.string,

  /** Boolean value for whether the menu is open or not */
  open: PropTypes.bool.isRequired,

  /** Custom function for handling onclick functionality */
  handleClick: PropTypes.func.isRequired
};
export var BurgerMenu = createThemedComponent('BurgerMenu', BurgerMenuComponent);
export default BurgerMenu;